(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-shop"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('.qsd__range').forEach((range) => {

  if (range.dataset.ready === 'true') return;

  range.dataset.ready = 'true';

  const select =
    range.querySelector('[data-qsd-select]');

  const price =
    range.querySelector('[data-qsd-price]');

  const qty =
    range.querySelector('[data-qsd-qty]');

  const button =
    range.querySelector('[data-qsd-add]');

  const buttonText =
    range.querySelector('[data-qsd-button-text]');

  const message =
    range.querySelector('[data-qsd-message]');


  /* PRODUCT / SHADE SELECT */

  select.addEventListener('change', () => {

    const option =
      select.options[select.selectedIndex];

    price.textContent =
      select.value
        ? option.dataset.price
        : '';

    button.disabled =
      !select.value;

    message.textContent = '';

  });


  /* ADD TO BASKET */

  button.addEventListener('click', async () => {

    if (!select.value) return;

    button.disabled = true;

    const originalText =
      buttonText.textContent;

    buttonText.textContent =
      'Adding…';

    message.textContent = '';

    try {

      const root =
        window.Shopify && Shopify.routes
          ? Shopify.routes.root
          : '/';

      const response =
        await fetch(root + 'cart/add.js', {

          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },

          body: JSON.stringify({

            items: [
              {
                id: Number(select.value),
                quantity: Math.max(
                  1,
                  Number(qty.value) || 1
                )
              }
            ]

          })

        });


      if (!response.ok) {

        throw new Error(
          'This item could not be added. Please check its availability.'
        );

      }


      /* Send customer to basket */

      window.location.href =
        root + 'cart';


    } catch (error) {

      message.textContent =
        error.message;

      button.disabled = false;

      buttonText.textContent =
        originalText;

    }

  });

});


  } catch(e) { console.error(e); }
})();
})();
